"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class EventsBus {
    constructor() {
        this.bus = {};
    }
    subscribe(key, handler) {
        if (this.bus[key] === undefined) {
            this.bus[key] = [];
        }
        this.bus[key].push(handler);
    }
    unsubscribe(key, handler) {
        if (this.bus[key] === undefined) {
            return;
        }
        const idx = this.bus[key].indexOf(handler);
        if (idx < 0) {
            return;
        }
        this.bus[key].splice(idx, 1);
    }
    emit(key, payload) {
        var _a;
        (_a = this.bus[key]) === null || _a === void 0 ? void 0 : _a.forEach((handler) => {
            handler(payload);
        });
    }
}
exports.default = EventsBus;
;
